import { Box, Select, MenuItem } from "@mui/material";
import { useState, useEffect, useContext } from "react";
import { AppContext } from "contexts/AppContext";
import { useDebounce } from "utils/useDebounce"
import ContentSmall from "components/elements/ContentSmall";
import { alpha } from '@mui/material/styles';

export function ParcelShopSelection(props) {
  const { zipcode, address, selectedParcelShopNumber, setSelectedParcelShopNumber, readOnly } = props;
  const debouncedAddress = useDebounce(address, 700)
  const debouncedZip = useDebounce(zipcode, 700)
  const [parcelShops, setParcelShops] = useState([]);
  const { styleGuide } = useContext(AppContext);

  const fetchParcelShops = async () => {
    // Fetch parcel shops based on zipcode and streetName
    const parcelShopAmount = 7; // Number of parcel shops to fetch
    const glsBaseUrl = "https://www.gls.dk/webservices_v4/wsShopFinder.asmx/SearchNearestParcelShops";

    const requestUrl = `${glsBaseUrl}?countryIso3166A2=DK&zipcode=${debouncedZip}&street="${debouncedAddress.trim()}"&amount=${parcelShopAmount}`;
    const response = await fetch(requestUrl);
    if(response.status !== 200) {
      setParcelShops([]);
      return;
    }
    const xmlText  = await response.text(); // Reponse is xml
    const xml = new DOMParser().parseFromString(xmlText , "text/xml");

    const shops = [...xml.querySelectorAll("PakkeshopData")].map(shop => ({
      number: shop.querySelector("Number")?.textContent,
      companyName: shop.querySelector("CompanyName")?.textContent,
      street: shop.querySelector("Streetname")?.textContent,
      zipCode: shop.querySelector("ZipCode")?.textContent,
      city: shop.querySelector("CityName")?.textContent,
      distance: Number(
        shop.querySelector("DistanceMetersAsTheCrowFlies")?.textContent
      ),
    }));

    setParcelShops(shops);
  };

  useEffect(() => {
    if (debouncedZip && debouncedAddress && debouncedZip.length === 4 && debouncedAddress.length > 0) {
      fetchParcelShops();
    }
  }, [debouncedZip, debouncedAddress]);

  const menuItemStyle = {
    padding: 2,
    '&.Mui-selected': {
      backgroundColor: alpha(styleGuide.color16, 0.1),
    },
    '&.Mui-selected:hover, &.Mui-selected.Mui-focusVisible': {
      backgroundColor: alpha(styleGuide.color16, 0.2),
    },
  };

  return (
    <Box display="flex" flex={1}>
      <Select
        value={selectedParcelShopNumber}
        disabled={readOnly}
        onChange={(event) => {
          const selectedNumber = event.target.value;
          setSelectedParcelShopNumber(selectedNumber);
        }}
        style={{
          borderRadius: 14,
          border: `1px solid ${styleGuide.color4}`,
          fontSize: '14px',
          flex: 1,
        }}
        sx={{
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: styleGuide.color16,
          },
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              maxHeight: 300,
              borderRadius: 3,
            }
          }
        }}
      >
        <MenuItem key={'default'} value={0} sx={menuItemStyle}>
          <Box display="flex" flexDirection="column">
            <ContentSmall
              style={{ fontWeight: 'bold', marginRight: 1 }}
              translationKey="_PRIVATE_DELIVERY_"
              fallbackText="Privatlevering"
            />
            <ContentSmall
              style={{ color: styleGuide.color6 }}
              translationKey="_DELIVERY_TO_USER_ADDRESS_"
              fallbackText="Levering til min adresse"
            />
          </Box>
        </MenuItem>
        {parcelShops.map((shop) => {
          return (
            <MenuItem key={shop.number} value={shop.number} sx={menuItemStyle}>
              <Box display="flex" flexDirection="column">
                <ContentSmall style={{ fontWeight: 'bold', marginRight: 1 }}>
                  {shop.companyName}
                </ContentSmall>
                <ContentSmall style={{ color: styleGuide.color6 }}>
                  {shop.street}
                </ContentSmall>
                <ContentSmall style={{ color: styleGuide.color6 }}>
                  {shop.zipCode} {shop.city} ({(shop.distance / 1000).toFixed(2)} km)
                </ContentSmall>
              </Box>
            </MenuItem>
          )
        })}
      </Select>
    </Box>
  )
}